<template>
  <div>
    <div>
      <div class="file-selector">
        <strong>{{ $t('Select Files from:') }}</strong>

        <v-container fluid>
          <!-- Google Drive -->
          <v-btn fab @click="connectToGDrive">
            <v-img src="/logos/drive.svg" class="rounded-logo"></v-img>
          </v-btn>

          <!-- Box -->
          <v-btn fab @click="connectToBox()">
            <v-img src="/logos/box.svg" class="rounded-logo"></v-img>
          </v-btn>

          <!-- DropBox -->
          <v-btn fab @click="connectToDropbox()">
            <v-img src="/logos/dropboxrounded.svg" class="rounded-logo"></v-img>
          </v-btn>

        </v-container>

      </div>

      <!-- List Attached files -->
      <AttachmentList :tempAttachments="getTempAttachments"/>
    </div>

    <!-- Add Box Preview Container -->
    <div>
      <div v-show="isUsingBox" class="preview-container" style="height:400px; width:100%; display: none"></div>
    </div>

    <!-- Progresss Bar Loading file -->
    <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>

    <v-snackbar
        v-model="snackbar"
        color="primary"
        :multi-line="true"
        :timeout=20000
    >
      {{ snackbar_text }}
      <v-btn
          dark
          flat
          @click="snackbar = false"
      >
        {{ $t('Close') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<style scoped>

.vcardc .layout {
  max-height: 500px;
}

.rounded-logo {
  border-radius: 50%;
}
</style>

<script>
import ExternalLoader from '@/lib/external-loader'
import SourcesRepository from '@/repositories/SourcesRepository'
import LocalRepository from '@/repositories/LocalRepository'
import AttachmentList from "./AttachmentList";
import config from "../../config"
import {VBtn, VContainer, VImg, VProgressLinear, VSnackbar} from 'vuetify/lib'

export default {
  components: {
    VImg,
    VSnackbar,
    VProgressLinear,
    VContainer,
    VBtn,
    AttachmentList: AttachmentList,
  },
  props: ['emails', 'email', 'permissionDownload', 'GivePermissionsView', 'GivePermissionsDownload', 'temporalPermissions', 'message', 'user'],
  data() {
    return {
      loading: false,
      tempAttachments: [],
      attachments: [],
      pickerApiLoaded: false,
      developerKey: "AIzaSyBLvG4rwC9GoCIyRZIPNS04WS9WgWASqT4",
      clientId: "412380384619-2ov04vfh9liub61llpbl32aetgrnr2u9.apps.googleusercontent.com",
      scope: "https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/userinfo.profile",
      oauthToken: null,
      user_name: null,
      connected_tokens: [],
      accounts: {},
      snackbar_text: "",
      snackbar: false,
      validMimetypes: ["application/pdf", "image/tiff", "image/jpeg", "image/png", "application/step", "application/iges", "application/obj", "model/3dm", "application/3dm", "application/3dm", "application/rhino", "text/plain", "application/x-zip-compressed", "application/3mf"],
      loaded: false,

      //  GDrive
      token: null,

      // Box
      isUsingBox: false,
      boxToken: null,
      boxRefreshToken: null,

      //  DropBox
      isUsingDropBox: false,
      dropboxToken: null,
      dropboxRefreshToken: null,
    }
  },
  watch: {
    accounts: function (val) {
      for (let account in val) {
        if (!val[account]) {
          this.removeAccount(account);
        }
      }
    },
    tempAttachments: function () {
      this.$emit('update_cost', this.getSelectedFiles().length);
    },
    loaded: function () {
      this.boxScriptloaded();
      this.dropBoxScriptloaded()

      //Load tempAttachments
      if (LocalRepository.has('tempAttachment')) {
        const tempValue = LocalRepository.get('tempAttachment');
        if (tempValue) {
          this.tempAttachments = JSON.parse(tempValue);
          LocalRepository.clear('tempAttachment');
        }
      }

    },
  },
  computed: {
    getTempAttachments() {
      return this.tempAttachments;
    },
    getAttachments() {
      return this.attachments;
    }
  },
  created() {
    //Initialize Constants
    this.validExtensions = [".pdf", ".tiff", ".tif", ".jfif", ".pjpeg", ".jpeg", ".pjp", ".jpg", ".png", ".step", ".stp", ".igs", ".iges", ".obj", ".3dm", ".3mf", ".doc", ".docx", ".odt", ".ods", ".xlsx", ".xls", ".odp", ".pptx", ".ppt", ".txt", ".rtf", ".odg"];

    let gDrive = document.createElement("script");
    gDrive.setAttribute("type", "text/javascript");
    gDrive.setAttribute("src", "https://apis.google.com/js/api.js");
    document.head.appendChild(gDrive);

    //Google Drive
    if (this.$route.query.code) {
      this.checkCode(this.$route.query.code, "GDRIVE");
    }

    if (this.user) {
      SourcesRepository.getConnectedAccounts().then((response) => {
        if (response && response.data && response.data.tokens && response.data.tokens.length > 0) {
          for (let i = 0; i < response.data.tokens.length; i++) {
            this.addConnectedToken(response.data.tokens[i]);
          }
        }
      });
    } else if (LocalRepository.has("cached_token")) {
      let local_token = LocalRepository.get("cached_token");
      this.addConnectedToken(JSON.parse(local_token));
    }
  },
  async mounted() {
    /* Dropbox */
    let dropBox = document.createElement("script");
    dropBox.setAttribute(
        "src",
        "https://www.dropbox.com/static/api/2/dropins.js"
    );
    dropBox.setAttribute("id", "dropboxjs");
    dropBox.setAttribute("data-app-key", "on1d7ljsrikarp0");
    document.head.appendChild(dropBox);

    /* Box */
    let loader = new ExternalLoader(document);
    let resources = ["https://cdn01.boxcdn.net/platform/elements/15.0.0/en-US/explorer.js", "https://cdn01.boxcdn.net/platform/elements/15.0.0/en-US/explorer.css"];
    loader.load(resources).then(() => {
      this.loaded = true
    });
  },
  methods: {

    /**
     Google Drive Functions
     */

    connectToGDrive() {
      if (this.connected_tokens.length > 0) {
        this.connectedToken(this.connected_tokens[0]);
      } else {
        this.saveData();

        SourcesRepository.getToken().then((response) => {

          //Save tempAttachments
          if (this.tempAttachments.length > 0) {
            LocalRepository.set('tempAttachment', JSON.stringify(this.tempAttachments));
          }

          window.location = response.data.url;
        });
      }
    },

    load_picker(token) {
      gapi.load("picker", () => {
        //console.log("Picker Loaded");
        this.pickerApiLoaded = true;
        this.oauthToken = JSON.parse(token).access_token;
        //var mimetypes = "application/pdf,application/vnd.google-apps.document,application/vnd.google-apps.spreadsheet,application/vnd.google-apps.presentation,model/iges,image/tiff,image/png,image/jpeg,application/vnd.ms-pki.stl";
        var picker = new google.picker.PickerBuilder()
            .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
            .enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES)
            .addView(new google.picker.DocsView().setIncludeFolders(true).setOwnedByMe(true))
            .addView(new google.picker.DocsView().setIncludeFolders(true).setOwnedByMe(false))
            //.setSelectableMimeTypes(mimetypes)
            .setOAuthToken(this.oauthToken)
            .setDeveloperKey(this.developerKey)
            .setCallback(this.pickerCallback)
            .build();
        picker.setVisible(true);
        this.loading = false;
      });
    },

    checkCode(code) {
      this.loading = true;

      // clear url
      let query = Object.assign({}, this.$route.query);
      delete query.code;
      this.$router.replace({query});

      SourcesRepository.getFiles(code).then((response) => {
        if (response && response.data) {
          this.token = response.data.token;
          this.user_name = response.data.user_info.name;
          if (this.email.length === 0) this.email = response.data.user_info.email;

          if (this.user) {
            this.addConnectedToken({
              email: response.data.user_info.email,
              name: response.data.user_info.name,
              token: this.token
            });
          } else {
            let cached_token = {token: this.token, name: this.user_name, email: this.email};
            LocalRepository.set("cached_token", JSON.stringify(cached_token));
            this.addConnectedToken(cached_token);
          }

          this.connected();
        }
      }).catch(() => {
        this.loading = false;
      });
    },


    /**
     Box Functions
     */

    connectToBox() {
      if (this.boxToken && this.boxRefreshToken) {
        this.boxScriptloaded();
      } else {
        this.saveData();
        SourcesRepository.getBoxToken().then((response) => {

          //Save tempAttachments
          if (this.tempAttachments.length > 0) {
            LocalRepository.set('tempAttachment', JSON.stringify(this.tempAttachments));
          }

          window.location = response.data.url;
        });
      }
    },


    boxScriptloaded() {
      if (this.loaded) {
        if (this.$route.query.boxtoken) {
          this.boxToken = this.$route.query.boxtoken;
          this.boxRefreshToken = this.$route.query.boxrefresh;
          LocalRepository.set('boxTokens', JSON.stringify({
            accessToken: this.boxToken,
            refreshToken: this.boxRefreshToken,
            expireDate: this.$moment().add(1, 'hours')
          }));
        } else if (LocalRepository.has('boxTokens')) {
          const boxTokens = JSON.parse(LocalRepository.get('boxTokens'));

          if (this.$moment().isBefore(this.$moment(boxTokens.expireDate))) {
            this.boxToken = boxTokens.accessToken;
            this.boxRefreshToken = boxTokens.refreshToken;
          } else {
            LocalRepository.clear('boxTokens');
            this.boxToken = null;
            this.boxRefreshToken = null;
          }
        }
        this.checkBoxToken(this.boxToken, this.boxRefreshToken);
      }
    },

    checkBoxToken(token, refreshToken) {
      if (token && refreshToken) {
        this.isUsingBox = true;
        this.loadBoxExplorer(token, refreshToken);
      }
    },

    hasValidExtension(extension, fileName) {
      const hasValidExtension = this.validExtensions.find(element => {
        if (element.includes(extension)) {
          return true;
        }
      });

      if (!hasValidExtension) {
        // Show snackbar message
        const extensions = this.validExtensions.join(', ')
        this.snackbar_text = fileName + this.$t(" not valid. Select one of the following types: ") + extensions;
        this.snackbar = true;
      }

      return hasValidExtension;
    },

    loadBoxExplorer(token, refreshToken) {
      const contentExplorer = new Box.ContentExplorer();
      // 0 Indicates root Folder
      const folderId = "0";

      contentExplorer.addListener("select", (selectedFile) => {
        if (Array.isArray(selectedFile) && selectedFile.length > 0) {
          if (selectedFile[0].type === "file") {

            const file = selectedFile[0];

            this.addAttachment(file.id,
                  file.name,
                  null,
                  "Box Selected File",
                  file.extension,
                  "",
                  file.size,
                  null,
                  "BOX",
                  token,
                  refreshToken
              );
            // Try to close contentExplorer on selected File
            // contentExplorer.hide();
          }
        }
      });

      contentExplorer.show(folderId, token, {
        container: ".preview-container"
      });
    },

    /**
     DropBox Functions
     */

    connectToDropbox() {
      if (this.dropboxToken && this.dropboxRefreshToken) {
        this.dropBoxScriptloaded();
      } else {
        this.saveData();
        SourcesRepository.getDropBoxtoken().then((response) => {

          //Save tempAttachments
          if (this.tempAttachments.length > 0) {
            LocalRepository.set('tempAttachment', JSON.stringify(this.tempAttachments));
          }

          window.location = response.data.url;
        });
      }
    },

    dropBoxScriptloaded() {
      if (this.loaded) {
        if (this.$route.query.dropboxtoken) {
          this.dropboxToken = this.$route.query.dropboxtoken;
          this.dropboxRefreshToken = this.$route.query.dropboxrefresh;
          LocalRepository.set('dropBoxTokens', JSON.stringify({
            accessToken: this.dropboxToken,
            refreshToken: this.dropboxRefreshToken,
            expireDate: this.$moment().add(1, 'hours')
          }));
        } else if (LocalRepository.has('dropBoxTokens')) {
          const dropboxTokens = JSON.parse(LocalRepository.get('dropBoxTokens'));

          if (this.$moment().isBefore(this.$moment(dropboxTokens.expireDate))) {
            this.dropboxToken = dropboxTokens.accessToken;
            this.dropboxRefreshToken = dropboxTokens.refreshToken;
          } else {
            LocalRepository.clear('dropBoxTokens');
            this.dropboxToken = null;
            this.dropboxRefreshToken = null;
          }
        }
        this.checkDropBoxToken(this.dropboxToken, this.dropboxRefreshToken);
      }
    },

    checkDropBoxToken(token, refreshToken) {
      if (token && refreshToken) {
        this.loadDropBoxExplorer(token, refreshToken);
      }
    },

    loadDropBoxExplorer(token, refreshToken) {
      let options = {
        success: async files => {

          for (let i = 0; i < files.length; i++) {
            this.addAttachment(files[i].id,
                files[i].name,
                "application/octet-stream",
                "DropBox Selected File",
                `${files[i].name.split(".")[1]}`,
                files[i].icon,
                files[i].bytes,
                null,
                "DROPBOX",
                token,
                refreshToken
            );
          }
        },
        cancel: function () {
        },
        linkType: "preview",
        multiselect: true,
        extensions: this.validExtensions,
        folderselect: false,
        sizeLimit: 102400000
      };

      if (typeof Dropbox !== "undefined") {
        Dropbox.choose(options);
      } else {
        // Show snackbar message
        this.snackbar_text = this.$t("Click again dropbox button to see your files folder and review that your browser didn't block it");
        this.snackbar = true;
      }


    },

    /**
     Util Functions
     */

    addConnectedToken(token) {
      let gtoken = JSON.parse(token.token);
      //console.log(gtoken);
      if (new Date() < new Date(gtoken.expiry_date)) {
        //console.log("live");
        let exists = false;
        for (let ctoken of this.connected_tokens) {
          if (ctoken.email == token.email) {
            exists = true;
            break;
          }
        }
        //console.log(token);
        if (!exists) {
          //console.log("adding");
          this.connected_tokens.push(token);
        }
      }
    },

    removeAccount(email) {
      if (LocalRepository.has("cached_token")) {
        let local_token = LocalRepository.get("cached_token");
        let json = JSON.parse(local_token);
        if (json.email == email) {
          LocalRepository.clear("cached_token");
        }
      }
      for (let ctoken of this.connected_tokens) {
        if (ctoken.email == email) {
          SourcesRepository.removeToken(email).then((response) => {

          });
        }
      }
    },

    connectedToken(token) {
      //this.email = token.email;
      //this.user_name = token.name;
      //this.$emit('update_email', this.email);
      //this.$emit('update_username', this.user_name);
      this.token = token.token;
      this.load_picker(token.token);
    },
    connected() {
      this.$emit('update_email', this.email);
      this.$emit('update_username', this.user_name);
      this.load_picker(this.token);
    },
    saveData() {
      //Initializing visualization
      this.isUsingBox = false;

      let data = {};
      data.emails = this.emails;
      data.email = this.email;
      data.permissionDownload = this.permissionDownload;
      data.GivePermissionsView = this.GivePermissionsView;
      data.GivePermissionsDownload = this.GivePermissionsDownload;
      data.temporalPermissions = this.temporalPermissions;
      data.message = this.message;
      //alert("Saving: " + JSON.stringify(data));
      LocalRepository.set('form_data', JSON.stringify(data));
    },

    getSelectedFiles() {
      var selected_files = [];
      if (this.tempAttachments) {
        for (let file of this.tempAttachments) {
          if (!file.token) {
            file.token = this.token;
          }
          selected_files.push(file);
          //console.log(file);
        }
      }
      return selected_files;
    },

    getMimeType(file) {
      let mimetype = file.mimetype;
      let originalname = file.originalname;
      if (mimetype === "application/octet-stream" || mimetype === "text/plain") {
        let extension = originalname.split('.').pop().toLowerCase();
        if (extension === "step" || extension === "stp") {
          mimetype = "application/step";
        } else if (extension === "igs" || extension === "iges") {
          mimetype = "application/iges";
        } else if (extension === "obj") {
          mimetype = "application/obj";
        } else if (extension === "3dm") {
          mimetype = "application/3dm";
        } else if (extension === "3mf") {
          mimetype = "application/3mf";
        } else if (extension === "rhino") {
          mimetype = "application/rhino";
        } else if (extension === "pdf") {
          mimetype = "application/pdf";
        } else if (extension === "tiff") {
          mimetype = "image/tiff";
        } else if (extension === "tif") {
          mimetype = "image/tiff";
        }
      } else if (mimetype.startsWith("application/vnd.google-apps")) {
        let mimetype_extension = mimetype.split('.').pop().toLowerCase();
        if (file.source === "GDRIVE" && mimetype_extension === "document") {
          mimetype = "application/pdf";
        } else if (file.source === "GDRIVE" && mimetype_extension === "presentation") {
          mimetype = "application/pdf";
        } else if (file.source === "GDRIVE" && mimetype_extension === "spreadsheet") {
          mimetype = "application/pdf";
        }
      }
      // Fix Linux
      if (mimetype === "model/iges") {
        mimetype = "application/iges";
      }
      return mimetype;
    },

    addAttachment(id, name, mimeType, description, extension, iconUrl, sizeBytes, user, storageType, fileToken, refreshToken) {

      let attachment = {};

      attachment._id = id;
      attachment.title = name;
      if (storageType === "gDrive") {
        attachment.name = name + "." + mimeType.split("/")[1];
        attachment.extension = "." + mimeType.substring(mimeType.lastIndexOf(".") + 1);
      } else {
        attachment.name = name;
        attachment.extension = "." + extension;
      }

      attachment.type = storageType;
      attachment.mimetype = mimeType;
      attachment.description = description;
      attachment.iconURL = "/logos/file.svg";
      attachment.size = sizeBytes;
      attachment.thumb = null;
      attachment.thumb_list = null;
      attachment.user = JSON.parse(localStorage.getItem("user"));
      attachment.token = fileToken;
      attachment.refreshToken = refreshToken;

      const hasValidExtension = this.hasValidExtension(attachment.extension, name);
      if (hasValidExtension) {

        // Check if file already Exists
        const fileAlreadyExists = this.tempAttachments.find(element => {
          if (element && element.type && element.type === attachment.type && element._id && element._id === attachment._id) {
            return true;
          }
        });

        if (!fileAlreadyExists) {
          this.tempAttachments.push(attachment);
        } else {
          this.snackbar_text = this.$t("We cannot add the file. It already exists in the list");
          this.snackbar = true;
        }
      }
    },

    async pickerCallback(data, type = "gDrive") {

      console.log("PickerCallback Files : ", data);
      console.log("PickerCallback Files : ", type);
      var url = "nothing";
      var name = "nothing";
      this.snackbar = false;
      this.snackbar_text = "";
      if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
        var doc = data[google.picker.Response.DOCUMENTS][0];
        url = doc[google.picker.Document.URL];
        name = doc.name;
        let docs = data.docs;

        for (let i = 0; i < docs.length; i++) {
          let attachment = {};
          attachment._id = docs[i].id;
          attachment.title = docs[i].name;
          attachment.name = docs[i].name + "." + docs[i].mimeType.split("/")[1];
          attachment.type = "gDrive";
          attachment.mimetype = docs[i].mimeType;
          attachment.description = "Shared with GDrive";
          attachment.extension = "." + docs[i].mimeType.substring(docs[i].mimeType.lastIndexOf(".") + 1);
          attachment.iconURL = docs[i].iconUrl;
          attachment.size = docs[i].sizeBytes;
          attachment.user = JSON.parse(localStorage.getItem("user"));
          attachment.thumb = null;
          attachment.thumb_list = null;

          // Get File Extension
          const fileExt = docs[i].name.split('.').pop();

          // Check if is valid extension
          const hasValidExtension = this.hasValidExtension("." + fileExt, docs[i].name);

          if (hasValidExtension) {
            this.tempAttachments.push(attachment);
          }

          // let mt = this.getMimeType(file);
          // if (!config.acceptEverything && this.validMimetypes.indexOf(mt) == -1) {
          //   if (this.snackbar_text.length > 0) this.snackbar_text += ", ";
          //   this.snackbar_text += docs[i].name;
          // } else {
          //   // attachments.push(attachment);
          //   this.tempAttachments.push(attachment);
          // }
        }
      } else {
        //console.log("Action " + data[google.picker.Response.ACTION]);
      }
      // if (this.snackbar_text.length > 0) {
      //   this.snackbar_text = this.$t("File format not accepted: ") + this.snackbar_text;
      //   this.snackbar = true;
      // }
      this.oauthToken = null;
      this.pickerApiLoaded = false;
      this.$emit('update_cost', this.getSelectedFiles().length);
    }
  }
}
</script>
